import {
  documentToReactComponents,
  Options,
} from '@contentful/rich-text-react-renderer';
import { ReactNode } from 'react';
import { logError } from 'utils/helpers';

export type ContentfulRichText = {
  raw: string;
};

const renderRichText = (
  richText: ContentfulRichText,
  options?: Options,
): ReactNode | null => {
  let component = null;

  try {
    const jsonObj = JSON.parse(richText.raw);
    component = documentToReactComponents(jsonObj, options);
  } catch (error) {
    logError('Error parsing rich text raw content.', {
      component: 'renderRichText',
      function: 'renderRichText',
      stackTrace: error,
    });
  }

  return component;
};

export default renderRichText;
